import * as React from "react";
import { connect } from "react-redux";

import { bindActionCreators } from "redux";
import { Grid, Icon, Button, Form, Text } from "tabler-react";
import { Modal } from "react-bootstrap";

import {
  applyWithoutRegistration,
  setPassword,
  resetJobApplyForm,
} from "../../actions";
import JobApplyForm from "./JobApplyForm.react";
import JobApplySuccess from "./JobApplySuccess.react";
import SavePasswordForm from "./SavePasswordForm.react";

class JobApplyWithoutRegistration extends React.Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);

    this.state = {
      name: "",
      email: "",
      mobile: "",
      password: "",
      files: {},
      error: {
        name: "",
        email: "",
        mobile: "",
        password: "",
      },
      isSubmitting: false,
    };
  }

  onSubmit(e) {
    e.preventDefault();
    this.setState(
      {
        error: {
          file: this.state.files.name
            ? ""
            : "A valid pdf/doc/docx resume required",
          name: this.state.name ? "" : "Name is required!",
          email: this.state.email ? "" : "A valid email is required !",
          mobile: this.state.mobile ? "" : "A valid mobile is required !",
        },
      },
      () => {
        if (
          this.state.error.file === "" &&
          this.state.error.name === "" &&
          this.state.error.email === "" &&
          this.state.error.mobile === ""
        ) {
          const { error, password, ...obj } = this.state;
          obj["job"] = this.props.job.id;
          this.props.applyWithoutRegistration(obj);
          this.setState({
            isSubmitting: true,
          });
        }
      }
    );
  }

  handlePasswordSubmit(e) {
    e.preventDefault();
    this.setState(
      {
        error: {
          email: this.state.email ? "" : "A valid email is required !",
          password: this.state.password ? "" : "Password required !",
        },
      },
      () => {
        if (this.state.error.password === "" && this.state.error.email === "") {
          this.props.setPassword({
            email: this.state.email,
            password: this.state.password,
          });
          this.setState({
            isSubmitting: true,
          });
          this.props.resetJobApplyForm();
        }
      }
    );
  }

  handleChange(e) {
    let validFileType = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (
      e.target.files &&
      validFileType.indexOf(e.target.files[0].type) !== -1
    ) {
      this.setState({
        files: e.target.files[0],
        error: {},
      });
    } else {
      this.setState({
        files: {},
        error: {
          file: "A valid pdf/doc/docx resume required",
        },
      });
    }
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      error: {},
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.applyWithoutRegisterResponse && this.state.isSubmitting) {
      this.setState({
        isSubmitting: false,
      });
    }
  }

  render() {
    const {
      open,
      handleClose,
      job,
      applyWithoutRegisterResponse,
      setPasswordResponse,
    } = this.props;

    const JobApplyFormComponent = (
      <JobApplyForm
        job={job}
        handleInputChange={this.handleInputChange}
        errors={this.state.error}
        handleSubmit={this.onSubmit}
        handleChange={this.handleChange}
        isSubmitting={this.state.isSubmitting}
      />
    );

    const JobApplySuccessComponent = (
      <JobApplySuccess
        width={"200px"}
        height={"200px"}
        message={`You have successfully applied for ${job.title} position`}
      />
    );

    return (
      <Modal show={open}>
        <Icon
          className="close-btn-2"
          prefix="fe"
          name="x"
          onClick={handleClose}
        />
        <Grid.Row>
          <Grid.Col>
            {applyWithoutRegisterResponse.success
              ? JobApplySuccessComponent
              : JobApplyFormComponent}
            {applyWithoutRegisterResponse.success &&
            applyWithoutRegisterResponse.user ? (
              <SavePasswordForm
                handleSubmit={this.handlePasswordSubmit}
                handleChange={this.handleInputChange}
                values={this.state}
                errors={this.state.error}
              />
            ) : (
              <noscript />
            )}
            {setPasswordResponse.success ? (
              JobApplySuccessComponent
            ) : (
              <noscript />
            )}
          </Grid.Col>
        </Grid.Row>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    applyWithoutRegisterResponse: state.applyWithoutRegister,
    setPasswordResponse: state.setPasswordResponse,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setPassword,
      applyWithoutRegistration,
      resetJobApplyForm,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobApplyWithoutRegistration);
